import { ActionType, ReduxStateType } from '@/types/fitting-hardware';
import {
  SET_HARDWARE_OPTIONS,
  SET_SELECTED_HARDWARE_OPTION,
  SET_PAGE_VALUE,
  SET_HARDWARE_SELECTION_HINT,
  SET_HARDWARE_SELECTION_ENABLED,
  SET_ACCESS_TYPE,
  REMOVE_SELECTED_HARDWARE_OPTION,
  SET_NEW_SELECTED_HARDWARE_OPTION,
} from './action-types';

export const reducer = (state = {} as ReduxStateType, action: ActionType) => {
  switch (action.type) {
    case SET_HARDWARE_OPTIONS:
      return {
        ...state,
        hardwareOptions: action.value,
      };
    case SET_SELECTED_HARDWARE_OPTION:
      return {
        ...state,
        hardwareOptions: state.hardwareOptions.map((option, index) => ({
          ...option,
          selected: action.value === index ,
        })),
      };
    case SET_NEW_SELECTED_HARDWARE_OPTION:
      return {
        ...state,
        hardwareOptions: state.hardwareOptions.map((option, index) => ({
          ...option,
          selected: action.value === index ? true : option.selected,
        })),
      };
    case SET_PAGE_VALUE:
      return {
        ...state,
        cmsContent: action.value.cmsContent,
      };
    case SET_HARDWARE_SELECTION_HINT:
      return {
        ...state,
        hardwareSelectionHint: action.value,
      };
    case SET_HARDWARE_SELECTION_ENABLED:
      return {
        ...state,
        hardwareSelectionEnabled: action.value
      }
    case SET_ACCESS_TYPE:
      return {
        ...state,
        accessType: action.value
      }
    case REMOVE_SELECTED_HARDWARE_OPTION:
      return {
        ...state,
        hardwareOptions: state.hardwareOptions.map((option, index) => ({
          ...option,
          selected: action.value === index ? false : option.selected,
        })),
      };
    default:
      return state;
  }
};

export default reducer;

export const getHardwareOptions = (state: ReduxStateType) => state.hardwareOptions || [];
export const getSelectedHardwareOption = (state: ReduxStateType) => state.hardwareOptions
  .find((ho) => ho.selected);
export const getCmsContent = (state: ReduxStateType) => state.cmsContent;
export const getHardwareSelectionHint = (state: ReduxStateType) => state.hardwareSelectionHint;
export const getHardwareSelectionEnabled = (state: ReduxStateType) => state.hardwareSelectionEnabled;
export const getAccessType = (state: ReduxStateType) => state.accessType;
